export default __webpack_public_path__ + "static/media/icons-indexing.620d5d16.svg";